export interface CountriesQueryFilter {
  text: string | null;
  includeArchived: boolean;
  approvalRequirement: number | null;
  approveType: number | null;
  approvalLevelId: number | null;
}
